"use client";
// Imports
import { X } from "lucide-react";
import { useEffect } from "react";
import { cva } from "class-variance-authority";
import useStore from "@/lib/state";
import Marquee from "react-fast-marquee";
import Link from "next/link";

const bannerStyles = cva(
  "sticky top-0 z-[99] flex-col items-center justify-center py-2 transition-all duration-500 2xl:flex w-full 2xl:overflow-x-visible",
  {
    variants: {
      showBanner: {
        true: "translate-y-0 opacity-100 pointer-events-auto",
        false: "opacity-0 pointer-events-none -translate-y-full",
      },
    },
    defaultVariants: {
      showBanner: true,
    },
  }
);

export function Banner({ banner }) {
  // First check to see if a banner exists.

  // Variables
  const { showBanner, setShowBanner } = useStore();

  useEffect(() => {
    setShowBanner(banner.showBanner);

    // if (!localStorage.getItem('hideBanner') && banner?.showBanner){
    //   setShowBanner(true);
    // } else if (JSON.parse(localStorage.getItem('hideBanner')).title !== banner?.title) {
    //   setShowBanner(true);
    // } else {
    //   setShowBanner(false);
    // }
  }, []);

  // useEffect(() => {
  //   const header = document.querySelector('header');

  //   if (header) {
  //     if (showBanner) {
  //       header.classList.add('lg:top-[100px]', 'top-[86px]');
  //       header.classList.remove('top-0');
  //     } else {
  //       header.classList.add('top-0');
  //       header.classList.remove('lg:top-[100px]', 'top-[86px]');
  //     }
  //   }
  // }, [showBanner]);

  function closebanner() {
    // localStorage.setItem('hideBanner', JSON.stringify({ hide: true, title: banner?.title }));
    setShowBanner(false);
  }

  if (!showBanner) return null;

  return (
    <div
      id="banner"
      style={{ backgroundColor: banner?.backgroundColor }}
      className={bannerStyles({
        showBanner,
      })}
    >
      <Marquee gradient={false} speed={50} autoFill={true}>
        <p className="mx-10 text-xs leading-tight lg:text-base">
          {banner?.link ? (
            <Link
              href={banner.link}
              target={banner.link.includes("http") ? "_blank" : "_self"}
            >
              <strong>{banner.title}</strong> &mdash; {banner.content}
            </Link>
          ) : (
            <>
              <strong>{banner?.title}</strong> &mdash; {banner?.content}
            </>
          )}
        </p>
      </Marquee>

      <button
        onClick={closebanner}
        className="absolute top-0 bottom-0 right-0 z-10 flex items-center"
      >
        <div className="mr-1 rounded-full text-foreground bg-background backdrop-blur-md size-6">
          <X />
        </div>
      </button>
    </div>
  );
}
